import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('http')) request = request.clone({ url: `${environment.apiUrl}${request.url}` });
  return next(request);
};
